export default {"src":"/_next/static/media/left_arrow.29f77f44.svg","height":25,"width":17,"blurWidth":0,"blurHeight":0};